import styled from 'styled-components';

import Button, { ButtonProps } from '~components/Button';

interface Props extends Pick<ButtonProps, 'onClick' | 'disabled' | 'variant'> {}

export default function ButtonDetail({ onClick, variant = 'light', disabled, ...props }: Props) {
  return (
    <Button variant={variant} size='sm' disabled={disabled} onClick={onClick} {...props}>
      자세히 보기
    </Button>
  );
}

const IconWrapper = styled.span`
  display: inline-flex;
  margin-left: 5px;
`;
